import * as React from 'react';
import Table from 'react-bootstrap/Table';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import Pagination from '@mui/material/Pagination';
import { NavLink } from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { postRequest } from '../../../lib/api';
import { AuthContext } from '../../../authContext/context';
import { useContext, useEffect, useRef, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Swal from 'sweetalert2';
import Tooltip from '@mui/material/Tooltip';
import Dropdown from 'react-bootstrap/Dropdown';
import AddIcon from '@mui/icons-material/Add';


import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import SearchIcon from '@mui/icons-material/Search';
import PhoneIcon from '@mui/icons-material/Phone';
import FormControl from '@mui/material/FormControl';
import TablePagination from '@mui/material/TablePagination';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import OutlinedInput from '@mui/material/OutlinedInput';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const names = [
    'Oliver Hansen',
    'Van Henry',
    'April Tucker',
    'Ralph Hubbard',
    'Omar Alexander',
    'Carlos Abbott',
    'Miriam Wagner',
    'Bradley Wilkerson',
    'Virginia Andrews',
    'Kelly Snyder',
];
export default function Email() {

    const [pages, setPages] = React.useState(2);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [customerList, setCustomerList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    // Search states
    const [searchFields, setSearchFields] = useState({
        id: '',
        name: '',
        email: '',
        phone: '',
    });

    const authCtx = useContext(AuthContext);
    const debounceRef = useRef();

    // Fetch customers
    const fetchCustomers = async (payloadFields = searchFields, pageVal = page) => {
        const payload = {
            ...payloadFields,
            page: pageVal,
            limit: 5,
        };

        setLoading(true);
        try {
            const response = await postRequest('private/customerList', payload, authCtx.token);
            if (response?.data) {
                setCustomerList(response.data.docs || []);
                setTotalPages(response.data.totalPages || 1);
            } else {
                setCustomerList([]);
                setTotalPages(1);
            }
        } catch (err) {
            setCustomerList([]);
            setTotalPages(1);
        } finally {
            setLoading(false);
        }
    };

    // On initial load and page change
    useEffect(() => {
        fetchCustomers(searchFields, page);
        // eslint-disable-next-line
    }, [page]);

    // Debounced search on fields change
    useEffect(() => {
        setPage(1);
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            fetchCustomers(searchFields, 1);
        }, 400);
        // eslint-disable-next-line
    }, [searchFields]);

    // Handle individual search input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSearchFields((prev) => ({ ...prev, [name]: value }));
    };

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const handleDelete = async (userId) => {
        const confirm = await Swal.fire({
            title: 'Are you sure?',
            text: 'Do you really want to delete this customer ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
        });

        if (confirm.isConfirmed) {
            try {
                const response = await postRequest(`private/deleteCustomer/${userId}`, {}, authCtx.token);
                if (response?.status === 200 || response?.success) {
                    Swal.fire('Deleted!', 'Customer has been deleted.', 'success');
                    fetchCustomers(searchFields, page);
                } else {
                    Swal.fire('Error', response?.message || 'Failed to delete customer', 'error');
                }
            } catch (err) {
                Swal.fire('Error', err?.message || 'Failed to delete customer', 'error');
            }
        }
    };

    const [age, setAge] = React.useState('');
    const [status, setStatus] = React.useState('');

    const handleChange = (event) => {
        setAge(event.target.value);
    };
    const handleChange1 = (event) => {
        setStatus(event.target.value);
    };



    const [personName, setPersonName] = React.useState([]);

    const handleChange2 = (event) => {
        const {
            target: { value },
        } = event;
        setPersonName(typeof value === 'string' ? value.split(',') : value);
    };
    return (
        <>
            <div className='page-header pb-3'>
                <h1 className='mt-0 mb-0'>Merge Fields Explorer</h1>

            </div>

            {/* Search Form */}
            <div className='page-top-formview mb-3'>
                <Form>
                    <Row className="mb-3">

                        <Form.Group as={Col} controlId="searchId">

                            <FormControl sx={{ my: 1, width: '100%' }} variant="outlined" >
                                <InputLabel id="demo-simple-select-label">Select Product</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={age}
                                    label="Product"
                                    onChange={handleChange}
                                >
                                    <MenuItem value={10}>Ten</MenuItem>
                                    <MenuItem value={20}>Twenty</MenuItem>
                                    <MenuItem value={30}>Thirty</MenuItem>
                                </Select>
                            </FormControl>
                        </Form.Group>


                    </Row>
                </Form>
                <div className='customer-tab-view'>
                    <Table striped responsive component="div"
                        count={100}
                        page={page}
                    >

                        <tbody>
                            <tr>
                                <td colSpan={2}><strong>Global</strong></td>
                            </tr>
                            <tr>
                                <td>Date</td>
                                <td className='merge-field'>Date</td>
                            </tr>
                            <tr>
                                <td colSpan={2}><strong>Lead</strong></td>
                            </tr>
                            <tr>
                                <td>Id</td>
                                <td className='merge-field'>Date</td>
                            </tr>
                            <tr>
                                <td>CreatedDate</td>
                                <td className='merge-field'>Date</td>
                            </tr>
                            <tr>
                                <td>CreatedTime</td>
                                <td className='merge-field'>Date</td>
                            </tr>
                            <tr>
                                <td>InstructUrl</td>
                                <td className='merge-field'>Date</td>
                            </tr>



                        </tbody>
                    </Table>
                    <TablePagination
                        component="div"
                        className='pagination'
                        count={100}
                        page={pages}
                        // onPageChange={handleChangePage}
                        rowsPerPage={rowsPerPage}
                    //onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </div>


            </div>

            {/* Table View */}
            <div>


                {/* Pagination */}
                {customerList.length > 0 && (
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
                        <Pagination
                            count={totalPages}
                            page={page}
                            onChange={handlePageChange}
                            color="primary"
                            shape="rounded"
                            size="medium"
                            sx={{
                                '& .Mui-selected': {
                                    backgroundColor: '#bb0000 !important',
                                    color: '#fff !important',
                                },
                                '& .MuiPaginationItem-root': {
                                    color: '#bb0000',
                                    borderColor: '#bb0000',
                                },
                            }}
                        />
                    </div>
                )}
            </div>
        </>
    );
}
